import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
	constructor(private router: Router, private authenticationService: AuthenticationService) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		const currentUser = this.authenticationService.currentUserValue;
		if (currentUser && currentUser.token) {
			// logged in so return true
			return true;
		}
		// not logged in so redirect to login page with the return url
		this.router.navigate([ '' ], { queryParams: { returnUrl: state.url } });
		return false;
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot): boolean {
		return this.checkPermission(childRoute);
	}

	checkPermission(route: ActivatedRouteSnapshot): boolean {
		const requiredPermission = route.data?.['permission'];
		if (!requiredPermission || !route.routeConfig?.path) return true;
		const userPermissions = this.authenticationService.currentUserValue?.permissions ?? {};
		if (requiredPermission && userPermissions.hasOwnProperty(requiredPermission)) {
			return true;
		} else {
			console.log("requiredPermission",requiredPermission, userPermissions)
			this.router.navigate(['/restricted']);
			//  this.router.parseUrl('/restricted');
			return false;
		}
	}
}
